import { useEffect, lazy, Suspense } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import AOS from 'aos';
import 'aos/dist/aos.css';

// Code splitting: cada página se carga solo cuando se necesita
const Home = lazy(() => import("./pages/Home.jsx"));
const Servicios = lazy(() => import("./pages/Servicios.jsx"));
const Cejas = lazy(() => import("./pages/Cejas.jsx"));
const BrowLamination = lazy(() => import("./pages/BrowLamination.jsx"));
const Nails = lazy(() => import("./pages/Nails.jsx"));
const KoreanLashLift = lazy(() => import("./pages/KoreanLashLift.jsx"));
const About = lazy(() => import("./pages/About.jsx"));
const Booking = lazy(() => import("./pages/Booking.jsx"));
const Contacto = lazy(() => import("./pages/Contacto.jsx"));
const DelValle = lazy(() => import("./pages/sucursales/DelValle.jsx"));
const Condesa = lazy(() => import("./pages/sucursales/Condesa.jsx"));
const Polanco = lazy(() => import("./pages/sucursales/Polanco.jsx"));
const Wedding = lazy(() => import("./pages/Wedding.jsx"));
const NotFound = lazy(() => import("./pages/NotFound.jsx"));

function App() {
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: 'ease-out',
      once: true,
      offset: 100,
      delay: 50
    });
  }, []);

  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Header />
          <Suspense fallback={<div style={{ minHeight: '60vh' }} />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/servicios" element={<Servicios />} />
              <Route path="/cejas" element={<Cejas />} />
              <Route path="/brow-lamination-cdmx" element={<BrowLamination />} />
              <Route path="/nails" element={<Nails />} />
              <Route path="/korean-lash-lift-cdmx" element={<KoreanLashLift />} />
              <Route path="/about" element={<About />} />
              <Route path="/booking" element={<Booking />} />
              <Route path="/contacto" element={<Contacto />} />
              <Route path="/wedding" element={<Wedding />} />
              <Route path="/sucursales/del-valle" element={<DelValle />} />
              <Route path="/sucursales/condesa" element={<Condesa />} />
              <Route path="/sucursales/polanco" element={<Polanco />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
          <Footer />
          
          {/* WhatsApp Floating Button */}
          <a 
            href="https://wa.me/525538784802" 
            target="_blank" 
            rel="noopener noreferrer"
            className="whatsapp-float"
            aria-label="Contactar por WhatsApp"
          >
            <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
              <path d="M16 0C7.163 0 0 7.163 0 16c0 2.828.735 5.482 2.018 7.783L.691 29.918l6.337-1.66A15.939 15.939 0 0016 32c8.837 0 16-7.163 16-16S24.837 0 16 0zm0 29.297c-2.394 0-4.742-.646-6.83-1.87l-.491-.291-5.093 1.336 1.357-4.964-.319-.508A13.239 13.239 0 012.703 16c0-7.318 5.954-13.271 13.271-13.271S29.245 8.682 29.245 16 23.291 29.271 16 29.271zm7.278-9.964c-.398-.199-2.354-1.162-2.72-1.295-.366-.133-.633-.199-.9.199-.266.398-1.031 1.295-1.263 1.56-.233.265-.466.299-.864.1-.398-.2-1.68-.62-3.2-1.976-1.183-1.056-1.982-2.361-2.215-2.76-.233-.398-.025-.613.175-.811.18-.179.398-.466.597-.699.199-.233.266-.398.398-.664.133-.266.066-.499-.033-.698-.1-.199-.9-2.168-1.232-2.968-.324-.78-.654-.674-.9-.687-.233-.012-.499-.015-.765-.015s-.698.1-1.064.499c-.366.398-1.397 1.362-1.397 3.322s1.43 3.854 1.629 4.12c.199.266 2.812 4.294 6.812 6.024.952.412 1.696.658 2.275.842.956.304 1.827.261 2.515.158.767-.115 2.354-.962 2.686-1.892.332-.93.332-1.727.233-1.892-.1-.165-.366-.265-.764-.465z"/>
            </svg>
          </a>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
